// dealer-locator.js - ALL data in JS (no JSON file needed)
document.addEventListener('DOMContentLoaded', function() {
  // ALL YOUR 300+ LOCATIONS GO HERE
  const allLocations = [
    {
      "name": "TRP WARWICK",
      "lat": -28.214,
      "lng": 152.025,
      "postcode": "4370",
      "region": "QLD",
      "address": "13011 Cunningham Highway, Sladevale QLD 4370",
      "phone": "07 4598 3100",
      "services": ["Parts", "Service"]
    },
    {
      "name": "TRP BUNDABERG",
      "lat": -24.866,
      "lng": 152.347,
      "postcode": "4870",
      "region": "QLD",
      "address": "104 Scotland St, Bundaberg East QLD 4870",
      "phone": "(07) 4153 1849",
      "services": ["Parts", "Trucks"]
    },
    {
      "name": "TRP GOSFORD",
      "lat": -33.424,
      "lng": 151.342,
      "postcode": "2250",
      "region": "NSW",
      "address": "2 Yandina Road, West Gosford NSW 2250",
      "phone": "02 4964 0697",
      "services": ["Service", "Trucks"]
    },
    {
      "name": "KENWORTH DAF MORWELL",
      "lat": -38.234,
      "lng": 146.396,
      "postcode": "3840",
      "region": "VIC",
      "address": "31 - 37 Alexanders Road, Morwell VIC 3840",
      "phone": "(03) 5134 4383",
      "services": ["Parts", "Service", "Trucks"]
    },
    {
      "name": "TRP SYDNEY",
      "lat": -33.868,
      "lng": 151.209,
      "postcode": "2000",
      "region": "NSW",
      "address": "123 George Street, Sydney NSW 2000",
      "phone": "02 9999 9999",
      "services": ["Parts", "Service"]
    },
    {
      "name": "TRP MELBOURNE",
      "lat": -37.813,
      "lng": 144.962,
      "postcode": "3000",
      "region": "VIC",
      "address": "456 Collins Street, Melbourne VIC 3000",
      "phone": "(03) 8888 8888",
      "services": ["Parts", "Service", "Trucks"]
    }
    // ADD YOUR 300+ MORE LOCATIONS HERE...
  ];
  
  console.log('Total locations loaded:', allLocations.length);
  
  // Initialize map
  const map = L.map('dealer-map').setView([-25, 135], 4);
  
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '© OpenStreetMap contributors',
    maxZoom: 18
  }).addTo(map);
  
  let markers = [];
  let filteredLocations = [...allLocations];
  let currentPage = 1;
  const locationsPerPage = 20;
  
  // Store marker references by location index
  const markerMap = new Map();
  
  // Initialize the app
  function initializeApp() {
    renderCurrentPage();
    setupEventListeners();
    updatePagination();
    updateMapView();
  }
  
  // Get marker color based on services
  function getMarkerColor(services) {
    if (!services || services.length === 0) return "#000000";
    if (services.includes("Service")) return "#2196f3";
    if (services.includes("Parts")) return "#4caf50";
    if (services.includes("Trucks")) return "#ff9800";
    return "#000000";
  }
  
  // Get badge class for styling
  function getBadgeClass(service) {
    if (!service) return '';
    switch(service.toLowerCase()) {
      case 'parts': return 'parts';
      case 'service': return 'service';
      case 'trucks': return 'trucks';
      default: return '';
    }
  }
  
  // Highlight marker when hovering on card
  function highlightMarker(locationIndex) {
    // Reset all markers to normal
    markers.forEach(marker => {
      const originalColor = getMarkerColor(marker._location?.services);
      marker.setStyle({
        radius: 8,
        weight: 2,
        fillOpacity: 0.7,
        color: originalColor,
        fillColor: originalColor
      });
    });
    
    // Highlight the specific marker
    const marker = markerMap.get(locationIndex);
    if (marker) {
      const originalColor = getMarkerColor(marker._location?.services);
      
      // Make marker darker and bolder
      marker.setStyle({
        radius: 12,       // Larger circle
        weight: 4,        // Thicker border
        fillOpacity: 1,   // Completely solid
        color: '#000000', // Black border for contrast
        fillColor: originalColor
      });
      
      marker.bringToFront();
      marker.openPopup();
      
      // Subtle bounce animation
      bounceMarker(marker);
      
      // Optional: Smoothly pan map to marker (not too aggressive)
      const currentZoom = map.getZoom();
      if (currentZoom < 8) {
        // Only pan if zoomed out far
        map.panTo(marker.getLatLng(), {
          animate: true,
          duration: 0.5,
          easeLinearity: 0.25
        });
      }
    }
  }
  
  // Add bounce animation to marker
  function bounceMarker(marker) {
    let scale = 1;
    let direction = 1;
    const bounceInterval = setInterval(() => {
      scale += direction * 0.1;
      if (scale >= 1.3) direction = -1;
      if (scale <= 1) {
        scale = 1;
        clearInterval(bounceInterval);
      }
      
      marker.setStyle({
        radius: 12 * scale
      });
    }, 50);
    
    // Store interval ID on marker to clear later
    marker._bounceInterval = bounceInterval;
  }
  
  // Remove highlight from all markers
  function removeHighlight() {
    markers.forEach(marker => {
      const originalColor = getMarkerColor(marker._location?.services);
      marker.setStyle({
        radius: 8,
        weight: 2,
        fillOpacity: 0.7,
        color: originalColor,
        fillColor: originalColor
      });
      
      // Stop any bounce animation
      if (marker._bounceInterval) {
        clearInterval(marker._bounceInterval);
        delete marker._bounceInterval;
      }
    });
    
    // Close all popups
    markers.forEach(marker => marker.closePopup());
  }
  
  // Filter locations based on current filters
  function filterLocations() {
    const regionSelect = document.getElementById('region');
    const postcodeInput = document.getElementById('postcode');
    const checkboxes = document.querySelectorAll('.checks input[type="checkbox"]:checked');
    
    const selectedRegion = regionSelect ? regionSelect.value : '';
    const postcodeFilter = postcodeInput ? postcodeInput.value.trim() : '';
    const selectedServices = Array.from(checkboxes).map(cb => cb.value);
    
    let filtered = allLocations;
    
    // Filter by region
    if (selectedRegion) {
      filtered = filtered.filter(location => 
        location.region && location.region.toUpperCase() === selectedRegion.toUpperCase()
      );
    }
    
    // Filter by postcode
    if (postcodeFilter) {
      filtered = filtered.filter(location => {
        const postcodeMatch = location.postcode && 
          location.postcode.toString().includes(postcodeFilter);
        const addressMatch = location.address && 
          location.address.toLowerCase().includes(postcodeFilter.toLowerCase());
        return postcodeMatch || addressMatch;
      });
    }
    
    // Filter by services
    if (selectedServices.length > 0) {
      filtered = filtered.filter(location => 
        location.services && 
        selectedServices.every(service => 
          location.services.includes(service)
        )
      );
    }
    
    return filtered;
  }
  
  // Get locations for current page
  function getCurrentPageLocations() {
    const startIndex = (currentPage - 1) * locationsPerPage;
    const endIndex = startIndex + locationsPerPage;
    return filteredLocations.slice(startIndex, endIndex);
  }
  
  // Update map markers
  function updateMapMarkers() {
    // Clear existing markers
    markers.forEach(marker => map.removeLayer(marker));
    markers = [];
    markerMap.clear();
    
    if (filteredLocations.length === 0) return;
    
    // Only add markers for current page locations
    const locationsToMark = getCurrentPageLocations();
    
    locationsToMark.forEach((location, index) => {
      if (location.lat && location.lng) {
        const markerColor = getMarkerColor(location.services);
        const marker = L.circleMarker([location.lat, location.lng], {
          radius: 8,
          color: markerColor,
          weight: 2,
          fillColor: markerColor,
          fillOpacity: 0.7
        }).addTo(map);
        
        // Store location data on marker for reference
        marker._location = location;
        
        // Add popup
        const popupContent = `
          <div style="padding: 10px; min-width: 200px;">
            <strong>${location.name || 'Unknown'}</strong><br>
            ${location.address || ''}<br>
            ${location.phone ? `📞 ${location.phone}` : ''}<br>
            ${location.services && location.services.length > 0 ? 
              `<div style="margin-top: 5px;">${location.services.map(s => 
                `<span style="background: ${getMarkerColor([s])}; color: white; padding: 2px 6px; margin: 2px; border-radius: 3px; font-size: 11px; display: inline-block;">${s}</span>`
              ).join(' ')}</div>` : ''}
          </div>
        `;
        
        marker.bindPopup(popupContent);
        markers.push(marker);
        
        // Store marker reference by index
        const globalIndex = (currentPage - 1) * locationsPerPage + index;
        markerMap.set(globalIndex, marker);
      }
    });
  }
  
  // Update dealer cards with hover effects
  function updateDealerCards() {
    const cardsContainer = document.getElementById('dealer-cards');
    if (!cardsContainer) return;
    
    cardsContainer.innerHTML = '';
    
    if (filteredLocations.length === 0) {
      cardsContainer.innerHTML = `
        <div class="no-results" style="grid-column: 1 / -1; text-align: center; padding: 40px; color: #666;">
          <p>No dealerships found matching your criteria.</p>
          <p>Try adjusting your filters or search for a different postcode.</p>
        </div>
      `;
      return;
    }
    
    const locationsToShow = getCurrentPageLocations();
    
    locationsToShow.forEach((location, localIndex) => {
      const card = document.createElement('div');
      card.className = 'dealer-card';
      
      // Calculate global index for this location
      const globalIndex = (currentPage - 1) * locationsPerPage + localIndex;
      
      // Format services badges
      const servicesHTML = location.services && location.services.length > 0 
        ? location.services.map(service => 
            `<span class="badge ${getBadgeClass(service)}">${service}</span>`
          ).join('')
        : '';
      
      // Build card content
      card.innerHTML = `
        <strong>${location.name || 'Unknown Dealership'}</strong>
        <div class="address">${location.address || ''}</div>
        ${location.phone ? `<div class="phone">📞 ${location.phone}</div>` : ''}
        ${location.postcode ? `<div class="postcode">Postcode: ${location.postcode}</div>` : ''}
        ${location.region ? `<div class="region" style="font-size: 12px; color: #888; margin-bottom: 10px;">Region: ${location.region}</div>` : ''}
        ${servicesHTML ? `<div class="services" style="margin-top: 10px;">${servicesHTML}</div>` : ''}
      `;
      
      // Add hover effects
      let hoverTimeout;
      
      card.addEventListener('mouseenter', () => {
        // Clear any existing timeout
        clearTimeout(hoverTimeout);
        
        // Highlight this card
        card.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
        card.style.borderColor = '#2196f3';
        card.style.transform = 'translateY(-2px)';
        
        // Highlight corresponding marker
        highlightMarker(globalIndex);
      });
      
      card.addEventListener('mouseleave', () => {
        // Remove highlight from card
        card.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
        card.style.borderColor = '#e0e0e0';
        card.style.transform = 'translateY(0)';
        
        // Remove highlight from marker after a small delay
        // (prevents flickering when moving between cards)
        hoverTimeout = setTimeout(() => {
          removeHighlight();
        }, 100);
      });
      
      // Add click event to center map on this location
      if (location.lat && location.lng) {
        card.style.cursor = 'pointer';
        card.addEventListener('click', () => {
          map.setView([location.lat, location.lng], 12);
          // Highlight the marker
          highlightMarker(globalIndex);
        });
      }
      
      cardsContainer.appendChild(card);
    });
  }
  
  // Update pagination controls
  function updatePagination() {
    let paginationContainer = document.getElementById('pagination-controls');
    
    if (!paginationContainer) {
      paginationContainer = document.createElement('div');
      paginationContainer.id = 'pagination-controls';
      paginationContainer.className = 'pagination-controls';
      document.querySelector('.dealer-cards').parentNode.appendChild(paginationContainer);
    }
    
    const totalPages = Math.ceil(filteredLocations.length / locationsPerPage);
    
    if (totalPages <= 1) {
      paginationContainer.innerHTML = '';
      return;
    }
    
    // Build pagination HTML
    let paginationHTML = `
      <div class="pagination-info">
        Showing <strong>${Math.min((currentPage - 1) * locationsPerPage + 1, filteredLocations.length)}-${Math.min(currentPage * locationsPerPage, filteredLocations.length)}</strong> 
        of <strong>${filteredLocations.length}</strong> dealerships
      </div>
      <div class="pagination-buttons">
    `;
    
    // Previous button
    if (currentPage > 1) {
      paginationHTML += `<button class="pagination-btn prev" onclick="changePage(${currentPage - 1})">← Previous</button>`;
    }
    
    // Page numbers (show limited range)
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
    
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }
    
    // First page
    if (startPage > 1) {
      paginationHTML += `<button class="pagination-btn" onclick="changePage(1)">1</button>`;
      if (startPage > 2) paginationHTML += `<span class="pagination-dots">...</span>`;
    }
    
    // Page numbers
    for (let i = startPage; i <= endPage; i++) {
      paginationHTML += `
        <button class="pagination-btn ${i === currentPage ? 'active' : ''}" 
                onclick="changePage(${i})">${i}</button>
      `;
    }
    
    // Last page
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) paginationHTML += `<span class="pagination-dots">...</span>`;
      paginationHTML += `<button class="pagination-btn" onclick="changePage(${totalPages})">${totalPages}</button>`;
    }
    
    // Next button
    if (currentPage < totalPages) {
      paginationHTML += `<button class="pagination-btn next" onclick="changePage(${currentPage + 1})">Next →</button>`;
    }
    
    paginationHTML += `</div>`;
    paginationContainer.innerHTML = paginationHTML;
  }
  
  // Update map view based on filtered locations
  function updateMapView() {
    if (filteredLocations.length === 0) return;
    
    const locationsWithCoords = filteredLocations.filter(loc => loc.lat && loc.lng);
    
    if (locationsWithCoords.length === 0) return;
    
    // Create bounds from all filtered locations
    const bounds = L.latLngBounds(locationsWithCoords.map(loc => [loc.lat, loc.lng]));
    
    // If only one location, zoom in closer
    if (locationsWithCoords.length === 1) {
      map.setView([locationsWithCoords[0].lat, locationsWithCoords[0].lng], 12);
    } else {
      map.fitBounds(bounds.pad(0.1));
    }
  }
  
  // Render current page
  function renderCurrentPage() {
    updateDealerCards();
    updateMapMarkers();
    updatePagination();
  }
  
  // Update display (called when filters change)
  function updateDisplay() {
    filteredLocations = filterLocations();
    currentPage = 1; // Reset to first page
    renderCurrentPage();
    updateMapView();
  }
  
  // Setup event listeners
  function setupEventListeners() {
    const regionSelect = document.getElementById('region');
    const postcodeInput = document.getElementById('postcode');
    const checkboxes = document.querySelectorAll('.checks input[type="checkbox"]');
    
    if (regionSelect) {
      regionSelect.addEventListener('change', updateDisplay);
    }
    
    if (postcodeInput) {
      let debounceTimer;
      postcodeInput.addEventListener('input', () => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(updateDisplay, 300);
      });
    }
    
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', updateDisplay);
    });
  }
  
  // Global function to change page
  window.changePage = function(page) {
    if (page < 1 || page > Math.ceil(filteredLocations.length / locationsPerPage)) return;
    
    currentPage = page;
    renderCurrentPage();
    
    // Smooth scroll to cards
    const cardsElement = document.querySelector('.dealer-cards');
    if (cardsElement) {
      window.scrollTo({
        top: cardsElement.offsetTop - 100,
        behavior: 'smooth'
      });
    }
  };
  
  // Global function to reset filters
  window.resetAllFilters = function() {
    const regionSelect = document.getElementById('region');
    const postcodeInput = document.getElementById('postcode');
    const checkboxes = document.querySelectorAll('.checks input[type="checkbox"]');
    
    if (regionSelect) regionSelect.value = '';
    if (postcodeInput) postcodeInput.value = '';
    checkboxes.forEach(checkbox => checkbox.checked = false);
    
    updateDisplay();
  };
  
  // Initialize the app
  initializeApp();
  
  console.log('Dealer locator loaded successfully with', allLocations.length, 'locations');
});